import type { ReactNode } from "react";

export interface IndexViewProps {
  /**
   * The connected marketplace search bar — a type-to-search field plus the Sort and
   * Filters pills sharing one `SearchBar` shell. Wired in the container (it reads
   * InstantSearch + sort state); this view only supplies its presentational shell.
   */
  searchBar: ReactNode;
}

/**
 * Presentational marketplace-index search-bar shell. It lives in the TopBar's
 * `bottomContent` slot so it persists across scrolls and gets the sticky bar's
 * scroll-away bottom border. Hidden below `md`, where the search-centric mobile top
 * bar provides the search pill + filters instead. All search wiring lives in the
 * container (`index.tsx`); this renders markup only.
 */
export function IndexView({ searchBar }: IndexViewProps) {
  return <div className="hidden border-neutral-100 border-b bg-white px-5 pb-6 md:block md:px-8">{searchBar}</div>;
}
